import cx from "classnames";

import { Modal } from "antd";

import styles from "./Modal.module.css";

function ModalMyRequest({
  title = "",
  width = 975,
  content = null,
  footer = null,
  className = "",
  isModalOpen = false,
  onCancel = () => { },
}) {
  return (
    <Modal
      title={title}
      maskClosable={false}
      open={isModalOpen}
      styles={{
        body: {
          maxHeight: "700px",
          overflowY: "auto",
        }
      }}
      onCancel={() => {
        const cancelBtn = document.getElementById("my-request__cancelBtn");
        // console.log("cancelBtn", cancelBtn);
        if (cancelBtn) {
          cancelBtn.click();
        } else {
          onCancel();
        }
      }}
      destroyOnClose
      className={cx(styles.customStyle, className)}
      width={width}
      footer={footer}
      closable={true}
    >
      <div style={{ minHeight: "400px", overflowY: "auto" }}>{content}</div>
    </Modal>
  );
}

export default ModalMyRequest;
